export const custom_headers = {
  x_team_id: 'x-hookdeck-team-id',
  // Accepted for existing clients; new requests should use x_team_id.
  x_team_id_legacy: 'x-team-id',
};

/** Prefer the namespaced header, falling back only when it is absent. */
export function getTeamIdHeader(
  headers: Record<string, string | string[] | undefined>
): string | string[] | undefined {
  return headers[custom_headers.x_team_id] ?? headers[custom_headers.x_team_id_legacy];
}

/** Header name for CLI telemetry JSON (Express lowercases to x-hookdeck-cli-telemetry) */
export const HOOKDECK_CLI_TELEMETRY_HEADER = 'x-hookdeck-cli-telemetry';

/** Header name for CLI client user-agent JSON (Express lowercases to x-hookdeck-client-user-agent) */
export const HOOKDECK_CLIENT_USER_AGENT_HEADER = 'x-hookdeck-client-user-agent';

/** The key only Inspect's server and the API share, sent on Inspect's console reads. */
export const INSPECT_SERVER_SECRET_HEADER = 'x-hookdeck-inspect-secret';
